/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarContact_viewer = {
    readonly isContactSupportEnabled?: boolean | null;
    readonly isMessageCenterEnabled?: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_viewer">;
    readonly " $refType": "PdpRespSidebarContact_viewer";
};
export type PdpRespSidebarContact_viewer$data = PdpRespSidebarContact_viewer;
export type PdpRespSidebarContact_viewer$key = {
    readonly " $data"?: PdpRespSidebarContact_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarContact_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarContact_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isContactSupportEnabled",
          "name": "isEnabledByLocale",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "CONTACT_1STDIBS"
            }
          ],
          "storageKey": "isEnabledByLocale(featureName:\"CONTACT_1STDIBS\")"
        },
        {
          "kind": "ScalarField",
          "alias": "isMessageCenterEnabled",
          "name": "isEnabledByLocale",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "MESSAGE_CENTER"
            }
          ],
          "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedContactDealerButton_viewer",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'c4967dd77b4be9bc87ef6a93c1a1fdee';
export default node;
